import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Documento, AttachmentDto } from '../../models/data.model';
import { CommonService } from '../../services/common.service';
import { EqualtecService } from '../../services/equaltec.service';
import { MimetypeService } from '../../services/mimetype.service';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-equaltec-search',
  templateUrl: './EqualtecSearch.component.html'
})
export class EqualtecSearch implements OnInit {

  public isTabellaSearchConUnElemento: boolean = false;
  public isTabellaSearchRevisionPending: boolean = false;
  public isExpandedSearch: boolean = false;
  //private isLegalentityTitleInterno:boolean = false;
  public labelNoRecord: boolean = false;
  public documentsFiltered: Documento[] = [];
  public searchFullText: string = "";
  public searchCodice: string = "";
  public searchOggetto: string = "";
  public checkBoxValue: string = "and";
  private docApertiSearch: number = 0;

  constructor(
    public translate: TranslateService,
    private equaltecService: EqualtecService,
    private documentService: CommonService<Documento>,
    private fileServer: CommonService<AttachmentDto>,
    private mimeTypeService: MimetypeService,
    private modalService: ModalService
  ) { }

  ngOnInit(): void {
  }

  documentDetail = (apridettaglio: string, codice: string, tipodocumento: string, revisione: string) => {
    if (apridettaglio == "Open detail") {
      this.openDocumentDetail(codice, tipodocumento, revisione);
    } else {
      this.closeDocumentDetail(codice, tipodocumento, revisione);
    }
  }

  openDocumentDetail = (codice: string, tipodocumento: string, revisione: string) => {
    this.docApertiSearch++;
    let documentiAperti = 0;
    this.isExpandedSearch = true;
    this.documentsFiltered.forEach(doc => {
      if (doc.isNewRevisionPending) {
        this.isTabellaSearchRevisionPending = true;
      }
      if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
        doc.metadatiDtoViewList = doc.metadatiDtoList;
        if (this.documentsFiltered.length > 1) {
          const y = { key: '', value: '' }
          doc.metadatiDtoViewList.splice(3, 0, y);
          doc.metadatiDtoViewList.splice(4, 0, y);
          if (this.isTabellaSearchRevisionPending) {
            doc.metadatiDtoViewList.splice(5, 0, y);
          }
        } else {
          this.isTabellaSearchConUnElemento = true;
        }
        doc.apriDettaglio = "Close detail";
      }
    })
    this.documentsFiltered.forEach(doc => {
      if (doc.apriDettaglio == "Close detail")
        documentiAperti++;
    })
    if (documentiAperti == this.equaltecService.documents.length && this.documentsFiltered.length > 1) {
      this.isTabellaSearchConUnElemento = true;
      this.documentsFiltered.forEach(doc => {
        const spl = this.isTabellaSearchRevisionPending ? 3 : 2;
        doc.metadatiDtoViewList.splice(3, spl);
      })
    }
  }

  closeDocumentDetail = (codice: string, tipodocumento: string, revisione: string) => {
    let documentiApertiFull = 0;
    this.documentsFiltered.forEach(doc => {
      if (doc.apriDettaglio == "Close detail")
        documentiApertiFull++;
    })
    if (documentiApertiFull == this.documentsFiltered.length && this.documentsFiltered.length > 1) {
      this.isTabellaSearchConUnElemento = false;
      this.documentsFiltered.forEach(doc => {
        const y = { key: '', value: '' }
        doc.metadatiDtoViewList.splice(3, 0, y);
        doc.metadatiDtoViewList.splice(4, 0, y);
        if (this.isTabellaSearchRevisionPending) {
          doc.metadatiDtoViewList.splice(5, 0, y);
        }
      })
    }
    this.docApertiSearch--;
    this.documentsFiltered.forEach(doc => {
      if (doc.codice == codice && doc.tipoDocumento == tipodocumento && doc.revisione == revisione) {
        if (this.documentsFiltered.length > 1) {
          const spl = this.isTabellaSearchRevisionPending ? 3 : 2;
          doc.metadatiDtoViewList.splice(3, spl);
        }
        doc.metadatiDtoViewList = doc.metadatiDtoShortList;
        doc.apriDettaglio = "Open detail";
      }
    })
    if (this.docApertiSearch == 0) {
      this.isExpandedSearch = false;
    }
  }

  getArcadocAttach(item: AttachmentDto, iddocumento: number, download: boolean) {
    const url = 'api/rest/GetAttachment';
    const params = {
      params: {
        idAllegato: item.idAllegato,
        idDocument: iddocumento,
        fileName: item.nomeFile,
        download: download
      }
    };
    this.fileServer.getData(url, params, false).toPromise()
      .then(res => {
        const attachment: AttachmentDto = res as AttachmentDto;
        const fileName = attachment.nomeFile;
        const ext = fileName.split('.').pop() || '';
        const downloadLink = document.createElement("a");
        this.dataURIToBlob(attachment.data, this.mimeTypeService.getMimeType(ext))
          .then(b => {
            const blob: Blob = b as Blob;
            const url = URL.createObjectURL(blob);
            if (download) {
              downloadLink.href = url;
              downloadLink.download = fileName;
              downloadLink.click();
            } else {
              window.open(url, '_blank')
            }
          })
      });
  }

  dataURIToBlob = (dataURI: any, mimeString: string) => {
    return new Promise(resolve => {
      const binStr = atob(dataURI),
        len = binStr.length,
        arr = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      const result = new Blob([arr], { type: mimeString });
      resolve(result)
    })
  }

  tabMenuAllegato = (doc: Documento) => {
    doc.ismenuAllegato = !doc.ismenuAllegato;
    const splitAll = doc.allegatoPrimarioDto.nomeFile.split('.');
    doc.allegatoPrimarioDto.estensione = splitAll[splitAll.length - 1];
  }

  tabMenuAllegatoSecondario = (doc: Documento) => {
    this.modalService.open(doc.allegatiSecondariDtoList, doc.idDocumento);
  }

  tabMenuAllegatoSecondarioList = (doc: Documento, attach: AttachmentDto) => {
    doc.allegatiSecondariDtoList.forEach(all => {
      if (all.nomeFile == attach.nomeFile) {
        all.isTabOpened = !all.isTabOpened;
      } else {
        all.isTabVisualizated = !all.isTabVisualizated;
      }
    })
  }

  onResultClicked = () => {
    let customtag = "";
    if (this.searchCodice) {
      customtag += "Codice," + this.searchCodice;
    }
    if (this.searchOggetto) {
      customtag += this.searchCodice != '' ? "#" : "";
      customtag += "Descrizione," + this.searchOggetto;
    }
    return this.showResult(customtag, this.searchFullText, this.searchOggetto);
  }

  showResult = (customtag: string, textTosearch: string, nomeAllegato: string) => {
    const url = 'api/rest/LoadFilteredEqualtecDocuments';
    if (this.checkBoxValue == null) {
      this.checkBoxValue = 'and';
    }
    const input = {
      customtag: customtag,
      fulltextquery: textTosearch,
      conjunction: this.checkBoxValue,
      filtrolegalEntity: this.equaltecService.selectedLegalEntity
    };
    this.documentService.postData(url, input, false).subscribe(result => {
      if (result) {
        console.log('this is documents : ', result);
        this.documentsFiltered = result as Documento[];
        this.documentsFiltered.forEach(d => {
          d.metadatiDtoViewList = d.metadatiDtoShortList;
          d.apriDettaglio = "Open detail";
          if (d.isNewRevisionPending) {
            this.isTabellaSearchRevisionPending = true;
          }
        });
        this.labelNoRecord = true
      }
    })
  }

}